//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import manba from 'manba'
import { axiosGet } from '../../../../../axios/axios.js'
import { mapGetters } from 'vuex'
import { EventBus } from '../../../../../EventBus/EventBus.js'

import MedicalScoreboardTimeTranslate from './MedicalScoreboardTimeTranslate.vue'

export default {
  components: {
    MedicalScoreboardTimeTranslate
  },
  props: {
    height: {
      type: Number,
      default: 400
    }
  },
  data: function () {
    return {
      scoreboardOpen: true,
      messageActualTranslate: '',
      dateTranslation: '',
      timerPart1: '',
      timerPart2: '',
      medicalSchedule: [],
      pagination: {
        rowsPerPage: 0
      },
      columns: [
        {
          name: 'employeeFIO',
          align: 'left',
          field: 'employeeFIO',
          sortable: true
        }
      ],
      classResize: '',
      timeoutStartClockId: 0,
      showScoreboardMedicalShedule: true,
      listWorkShiftMedical: null,
      timeoutStartActiveMedicalId: 0,
      employeePass: [],
      showBtnOut: false,
      widthResize: 242,
      zoomSize: 1.0,
      fontSize: 1.7
    }
  },
  computed: {
    ...mapGetters({
      pingResult: 'getPingResult'
    })
  },
  watch: {
    showScoreboardMedicalShedule: {
      handler: function (show) {
        EventBus.$emit('set-show-medical-shedule', { show: show, page: 'medicine-tablo' })
      },
      immediate: true
    },
    dateTranslation: function (data) {
      this.updateVideo()
    }
  },
  beforeDestroy: function () {
    clearTimeout(this.timeoutStartClockId)
    this.timeoutStartClockId = null
    clearTimeout(this.timeoutStartActiveMedicalId)
    this.timeoutStartActiveMedicalId = null

    this.showScoreboardMedicalShedule = false
    const videoFile = document.getElementById('videoTablo')
    if (videoFile) {
      while (videoFile.firstChild) {
        videoFile.removeChild(videoFile.firstChild)
      }
      videoFile.load()
    }
    EventBus.$emit('get-medical-shedule', false)
    EventBus.$off('show-employees-pass', this.showEmployeesPass)
  },
  updated () {
    this.updateVideo()
  },
  created: function () {
    this.showBtnOut = this.$d_hasRole('medicalAdmin')
    EventBus.$on('show-employees-pass', this.showEmployeesPass)
    this.startTimer()
  },
  methods: {
    startTimer () {
      const that = this
      setTimeout(function run () {
        const now = new Date()
        that.dateTranslation = manba(now.getTime()).format('DD-MM-YYYY')
        that.timerPart1 = manba(now.getTime()).format('HH')
        that.timerPart2 = manba(now.getTime()).format('mm')
        that.timeoutStartClockId = setTimeout(run, 1000)
      }, 1)
      setTimeout(function runActiveMedical () {
        that.getActiveMedical().then(function (reject) {
          EventBus.$emit('get-medical-shedule', that.showScoreboardMedicalShedule)
        })
        that.timeoutStartActiveMedicalId = setTimeout(runActiveMedical, 120000)
      }, 1)
    },
    showEmployeesPass: function (employeeId) {
      const that = this
      let idShowPhotos = setTimeout(function buildList () {
        if (employeeId) {
          const foundPass = that.employeePass.find(item => item.id == employeeId)
          if (foundPass == undefined) {
            that.$nextTick(() => {
              that.getEmployee(employeeId).then(function (reject) {
                that.employeePass = [...new Set([...[reject], ...that.employeePass])].slice(0, 2)
              })
            })
          }
          //
        }
        idShowPhotos = setTimeout(buildList, 2500)
        clearTimeout(idShowPhotos)
      }, 0)
      //
    },
    formatInitials: function (name) {
      if (!name) {
        return ''
      }
      const arrFullName = name.split(' ')
      return arrFullName[0] + ' ' +
             (arrFullName[1] ? (arrFullName[1].substring(0, 1) + '.') : '') + ' ' +
             (arrFullName[2] ? (arrFullName[2].substring(0, 1) + '.') : '')
    },
    stopShow: function () {
      this.showScoreboardMedicalShedule = false
    },
    getEmployee: function (id) {
      const urlName = '/service/delta/obj/properties?change=false&id=' + id + '&type=employee'
      return axiosGet({
        url: urlName,
        onSuccess: (response) => {
          const result = response.data.result
          return Promise.resolve({
            src: '/service/delta/document/thumbnail/' + (result.image ? result.image[0].id : 0) + '/200/200',
            fio: result.fio,
            id: id
          })
        },
        onFailure: (response) => {
          return Promise.reject(Error('Ошибка загрузки сотрудника'))
        }
      })
    },
    getSpacing: function (name) {
      const arrFullName = name.split(' ')
      let valueSpasing = 0
      if (arrFullName[0].length > 7 && arrFullName[0].length < 11) {
        valueSpasing = -2.2
      } else if (arrFullName[0].length >= 11) {
        valueSpasing = -4.8
      }
      return valueSpasing + 'px'
    },
    getActiveMedical: function () {
      const urlName = '/service/delta/journal/regularMedicalSchedule/hasActiveMedicalExam'
      return axiosGet({
        url: urlName,
        onSuccess: (response) => {
          const result = response.data.result
          this.showScoreboardMedicalShedule = result.isActive
          this.messageActualTranslate = ''
          if (this.listWorkShiftMedical && result.workShiftKey) {
            const foundActiveWorkShift = this.listWorkShiftMedical.find(item => item.key == result.workShiftKey)
            if (foundActiveWorkShift !== undefined) {
              this.messageActualTranslate = foundActiveWorkShift.name
            }
          }
          return Promise.resolve(result)
        }
        /* ,
        onFailure: (response) => {
          return Promise.reject(Error('Нет активных медосмотров'))
        } */
      })
    },
    showFestiveRoller: function () {
      // 07.03 - 09.03
      const today = new Date()
      const todayYear = today.getFullYear()
      const dateFrom = new Date(todayYear + '/03/07')
      const dateStop = new Date(todayYear + '/03/09')
      const timeZoneOffset = today.getTimezoneOffset() * 60 * 1000
      const todayUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0) + timeZoneOffset
      const dateFromUTC = Date.UTC(dateFrom.getFullYear(), dateFrom.getMonth(), dateFrom.getDate(), 0, 0, 0) + timeZoneOffset
      const dateStopUTC = Date.UTC(dateStop.getFullYear(), dateStop.getMonth(), dateStop.getDate(), 0, 0, 0) + timeZoneOffset
      return ((todayUTC >= dateFromUTC) && (todayUTC < dateStopUTC))
    },
    updateVideo: function () {
      const videoFile = document.getElementById('videoTablo')
      if (videoFile && !this.showScoreboardMedicalShedule) {
        if (document.getElementById('sourceTablo')) {
          while (videoFile.firstChild) {
            videoFile.removeChild(videoFile.firstChild)
          }
        }

        const source = document.createElement('source')
        source.setAttribute('id', 'sourceTablo')
        videoFile.appendChild(source)
        const sourceFile = document.getElementById('sourceTablo')
        videoFile.load()
        const nameFile = this.showFestiveRoller() ? 'tablo8march.mp4' : 'tablo_01.mp4'
        sourceFile.src = '/service/doc/read/video/' + nameFile
        sourceFile.type = 'video/mp4'
        videoFile.muted = true
        videoFile.load()
      } else if (videoFile && this.showScoreboardMedicalShedule) {
        while (videoFile.firstChild) {
          videoFile.removeChild(videoFile.firstChild)
        }
        videoFile.load()
      }
    }
  }
}

